import TourPage from "@/components/TourPage";

export default function GorillaSafari2Day() {
  return (
    <TourPage
      tourId="rwanda/gorilla-2-day"
      title="2 Days Rwanda Gorilla Safari"
      duration="2 Days / 1 Night"
      price="Contact for price"
      image="/rwandadoublegorilla.jpeg"
      description="Get ready for the thrill of tracking mountain gorillas in Volcanoes National Park on this 2-day Rwanda gorilla safari. Explore Kigali city, visit the Gisozi genocide memorial site, and trek through the jungle forest to encounter silverback gorillas."
      itinerary={[
        {
          day: 1,
          title: "Kigali City Tour & Transfer to Volcanoes National Park",
          description: "Begin your journey with a city tour before heading to the mountains.",
          activities: [
            "Early morning pickup from Kigali International Airport or hotel",
            "Kigali city tour, including the Gisozi genocide memorial site",
            "Transfer to Volcanoes National Park, Musanze province"
          ],
          accommodation: "Lodge near Volcanoes National Park",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "Mountain Gorilla Trek and Return to Kigali",
          description: "Experience the highlight of your trip - gorilla trekking.",
          activities: [
            "Early morning breakfast",
            "Morning briefing at Kinigi Park offices",
            "Mountain gorilla trekking in Volcanoes National Park",
            "Lunch and transfer back to Kigali",
            "Drop-off at Kigali International Airport or hotel"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "All meals (breakfast, lunch, and dinner)",
        "All park entrance fees and permits",
        "All activities, including mountain gorilla trekking",
        "Accommodation for 1 night",
        "Professional driver guide",
        "All activities (unless labeled as optional)"
      ]}
      exclusions={[
        "International flights (from/to home)",
        "Personal items (souvenirs, travel insurance, visa fees, etc.)",
        "Tip",
        "Coffee, soft drinks, snacks, and drinking water (on all days)",
        "Government-imposed increase of taxes and/or park Fees"
      ]}
    />
  );
}
